import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
    const messages = {}

    //Main locales
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)    
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })

    //Accounting locales
    const accounting = require.context('./locales/accounting', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    accounting.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].accounting = accounting(key)
        }
    })

    //Claims locales
    const claims = require.context('./locales/claims', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    claims.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].claims = claims(key)
        }
    })

    //Dashboard locales
    const dashboard = require.context('./locales/dashboard', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    dashboard.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].dashboard = dashboard(key)
        }
    })

    //Equipment locales
    const equipments = require.context('./locales/equipments', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    equipments.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].equipments = equipments(key)
        }
    })

    //Masters locales
    const masters = require.context('./locales/masters', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    masters.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].masters = masters(key)
        }
    })

    //Orders locales
    const orders = require.context('./locales/orders', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    orders.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].orders = orders(key)
        }
    })

    //Rma locales
    const rma = require.context('./locales/rma', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    rma.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].rma = rma(key)
        }
    })

    //Shared locales
    const shared = require.context('./locales/shared', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    shared.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].shared = shared(key)
        }
    })

    //Technical Documentation locales
    const technicaldocumentation = require.context('./locales/technicaldocumentation', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    technicaldocumentation.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].technicaldocumentation = technicaldocumentation(key)
        }
    })

    //Service Tickets locales
    const serviceTickets = require.context('./locales/servicetickets', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    serviceTickets.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].serviceTickets = serviceTickets(key)
        }
    })

    //Reports locales
    const reports = require.context('./locales/reports', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    reports.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].reports = reports(key)
        }
    })

    //Common locales
    const common = require.context('./locales/common', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    common.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale].common = common(key)
        }
    })


    return messages
}

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
})


// WEBPACK FOOTER //
// ./ClientApp/i18n.js